import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import DashboardLayout from "../../containers/Layout/DashboardLayout.jsx";
import RoundedPage from "../../../shared/components/Styled/Containers/RoundedPage.jsx";
import Positionings from "../../../shared/components/Freelance/Positionings.jsx";
import MyOffers from "../../../shared/components/Freelance/MyOffers.jsx";
import {connect} from "react-redux";
import withCurrentUniverse from "../../HOC/withCurrentUniverse.jsx";

class PositioningsAndMissions extends PureComponent {
  static propTypes = {
    user: PropTypes.object.isRequired,
    freelance: PropTypes.object.isRequired,
  };

  render() {
    const {freelance, user} = this.props.profile;
    const {generate, currentUniverseId} = this.props;
    return (
      <DashboardLayout>
        <div className="page-background print-no-color p-2 p-md-5">
          <RoundedPage>
            <div className="row">
              <div className="dashboard-row">
                <div className="dashboard-col">
                  <h2 className="text-center mt-3 ">
                    Positionnements et missions
                  </h2>
                </div>
              </div>
            </div>

            <h4 className="text-center my-5">Missions sur lesquelles j'ai été positionné(e)</h4>
            <Positionings user={user} positionings={freelance.positionings}/>
            <h4 className="text-center my-5">Missions auxquelles j'ai postulé</h4>
            <MyOffers currentUniverseId={currentUniverseId} generate={generate} user={user}/>
          </RoundedPage>
        </div>
      </DashboardLayout>
    )
  }
}

export default connect(
  (state) => (
    {currentUniverseId: state.universe?.currentUniverse.id ?? null}
  )
)(withCurrentUniverse(PositioningsAndMissions))
